import React from 'react'


interface Props {
  className?: string
  color?: string
}

const defaultClassName = 'w-8 h-8 stroke-current text-black';

export const LeftChevronSvg: React.FC<Props> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" className={props.className}>
      <path d="M11.5 14.5l-4-4 4-4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

LeftChevronSvg.defaultProps = {
  className: defaultClassName
}

export const RightChevronSvg: React.FC<Props> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" className={props.className}>
      <path d="M9.5 14.5l4-4-4-4" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

RightChevronSvg.defaultProps = {
  className: defaultClassName
}

export const UpChevronSvg: React.FC<Props> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" className={props.className}>
      <path fill="none" strokeLinecap="round" strokeLinejoin="round" d="M6.5 12.501l4-4 4 4" />
    </svg>
  )
}

UpChevronSvg.defaultProps = {
  className: defaultClassName
}

export const DownChevronSvg: React.FC<Props> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21" className={props.className}>
      <path d="M14.5 8.5l-4 4-4-4" fill="none" stroke="#2a2e3b" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

DownChevronSvg.defaultProps = {
  className: defaultClassName
}

export const DownDoubleChevronSvg: React.FC<Props> = (props) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13" className={props.className}>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.707 0.293C12.8945 0.480528 12.9998 0.734836 12.9998 1C12.9998 1.26516 12.8945 1.51947 12.707 1.707L7.70699 6.707C7.51946 6.89447 7.26515 6.99979 6.99999 6.99979C6.73483 6.99979 6.48052 6.89447 6.29299 6.707L1.29299 1.707C1.11083 1.5184 1.01004 1.2658 1.01232 1.0036C1.01459 0.741402 1.11976 0.49059 1.30517 0.305182C1.49058 0.119773 1.74139 0.0146042 2.00359 0.0123258C2.26579 0.0100473 2.51839 0.110842 2.70699 0.293L6.99999 4.586L11.293 0.293C11.4805 0.105529 11.7348 0.000213623 12 0.000213623C12.2652 0.000213623 12.5195 0.105529 12.707 0.293ZM12.707 6.293C12.8945 6.48053 12.9998 6.73484 12.9998 7C12.9998 7.26516 12.8945 7.51947 12.707 7.707L7.70699 12.707C7.51946 12.8945 7.26515 12.9998 6.99999 12.9998C6.73483 12.9998 6.48052 12.8945 6.29299 12.707L1.29299 7.707C1.19748 7.61475 1.1213 7.50441 1.06889 7.3824C1.01648 7.2604 0.988893 7.12918 0.987739 6.9964C0.986585 6.86362 1.01189 6.73194 1.06217 6.60905C1.11245 6.48615 1.1867 6.3745 1.28059 6.28061C1.37449 6.18671 1.48614 6.11246 1.60904 6.06218C1.73193 6.0119 1.86361 5.9866 1.99639 5.98775C2.12917 5.9889 2.26039 6.01649 2.38239 6.0689C2.5044 6.12131 2.61474 6.19749 2.70699 6.293L6.99999 10.586L11.293 6.293C11.4805 6.10553 11.7348 6.00021 12 6.00021C12.2652 6.00021 12.5195 6.10553 12.707 6.293Z" fill={props.color || 'black'} />
    </svg>
  )
}

DownDoubleChevronSvg.defaultProps = {
  className: defaultClassName
}
